/* ============================================================
   HOUSEP4RTY landing — stars, string lights, door-open sequence
   ============================================================ */

(function () {
  "use strict";

  /* ---------- build starfield ---------- */
  var sky = document.getElementById("sky");
  if (sky) {
    var starCount = 70;
    for (var i = 0; i < starCount; i++) {
      var star = document.createElement("div");
      star.className = "star";
      star.style.left = Math.random() * 100 + "%";
      star.style.top = Math.random() * 55 + "%";
      star.style.animationDelay = (Math.random() * 3).toFixed(2) + "s";
      star.style.animationDuration = (2.4 + Math.random() * 2.4).toFixed(2) + "s";
      sky.appendChild(star);
    }
  }

  /* ---------- build roofline string lights ---------- */
  var stringLights = document.getElementById("stringLights");
  if (stringLights) {
    var bulbCount = 22;
    for (var b = 0; b < bulbCount; b++) {
      var bulb = document.createElement("span");
      bulb.className = "bulb";
      stringLights.appendChild(bulb);
    }
  }

  /* ---------- original synthesized house-music loop (Web Audio) ----------
     No samples, no third-party tracks — every sound (kick, hat, clap, bass)
     is generated live from oscillators + noise, so there's nothing here
     that could carry a copyright claim. Runs on a lookahead scheduler so
     timing stays tight even if the tab briefly stutters. */
  var audioCtx = null;
  var masterGain = null;
  var noiseBuffer = null;
  var soundOn = false;
  var schedulerTimer = null;

  var BPM = 145; // modern trap/rap tempo, felt half-time
  var SIXTEENTH = 60 / BPM / 4;
  var LOOKAHEAD_MS = 25;
  var SCHEDULE_AHEAD = 0.12;
  var STEPS_PER_PHRASE = 32; // two bars of 16th notes (64 32nd-note hat slots)

  /* syncopated trap kick — original placement, not lifted from any track */
  var KICK_STEPS = [0, 10, 16, 20, 26];
  /* half-time snare/clap on "the 3" of each bar, plus a ghost rim before it */
  var SNARE_STEPS = [12, 28];
  var GHOST_STEPS = [9, 25];
  /* fast hats on every 16th, with a couple of 32nd-note rolls for that trap fill */
  var HAT_STEPS = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
  var HAT_ACCENT = [0, 8, 16, 24];
  var ROLL_STEPS = [6, 22]; // triggers a quick 32nd-note roll instead of a single hit
  var OPEN_HAT_STEPS = [14, 30];
  /* sliding 808 sub — original minor-key line, not from any specific song */
  var BASS_EVENTS = [
    { step: 0, freq: 55.0, glide: null, steps: 10 },
    { step: 10, freq: 49.0, glide: 43.65, steps: 6 },
    { step: 16, freq: 55.0, glide: null, steps: 6 },
    { step: 22, freq: 41.2, glide: 36.71, steps: 10 }
  ];
  var BASS_BY_STEP = {};
  BASS_EVENTS.forEach(function (ev) { BASS_BY_STEP[ev.step] = ev; });
  /* sparse dark bell/pluck motif — original 4-note phrase */
  var MELODY_STEPS = { 0: 440.0, 6: 392.0, 16: 349.23, 22: 392.0 };

  var currentStep = 0;
  var nextStepTime = 0;

  function ensureAudioCtx() {
    if (!audioCtx) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (AC) audioCtx = new AC();
      if (audioCtx) {
        masterGain = audioCtx.createGain();
        masterGain.gain.value = 0.55;
        masterGain.connect(audioCtx.destination);

        var len = audioCtx.sampleRate * 1; // 1s of noise, reused for hats/claps
        noiseBuffer = audioCtx.createBuffer(1, len, audioCtx.sampleRate);
        var data = noiseBuffer.getChannelData(0);
        for (var i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
      }
    }
    return audioCtx;
  }

  function playKick(time) {
    // punchy trap kick — short, deep, slightly distorted low end
    var osc = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    var shaper = audioCtx.createWaveShaper();
    var curve = new Float32Array(256);
    for (var i = 0; i < 256; i++) {
      var x = (i / 255) * 2 - 1;
      curve[i] = Math.tanh(x * 2.2);
    }
    shaper.curve = curve;
    osc.type = "sine";
    osc.frequency.setValueAtTime(150, time);
    osc.frequency.exponentialRampToValueAtTime(48, time + 0.09);
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.9, time + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.001, time + 0.2);
    osc.connect(shaper).connect(gain).connect(masterGain);
    osc.start(time);
    osc.stop(time + 0.22);
  }

  function playHat(time, accent) {
    var src = audioCtx.createBufferSource();
    src.buffer = noiseBuffer;
    var hp = audioCtx.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 8500;
    var gain = audioCtx.createGain();
    var dur = accent ? 0.05 : 0.03;
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(accent ? 0.22 : 0.11, time + 0.002);
    gain.gain.exponentialRampToValueAtTime(0.0001, time + dur);
    src.connect(hp).connect(gain).connect(masterGain);
    src.start(time);
    src.stop(time + dur + 0.02);
  }

  function playHatRoll(time, stepDur) {
    // quick 32nd-note roll fill, classic modern trap hi-hat move
    var hits = 3;
    for (var i = 0; i < hits; i++) {
      playHat(time + i * (stepDur / hits), i === hits - 1);
    }
  }

  function playOpenHat(time) {
    var src = audioCtx.createBufferSource();
    src.buffer = noiseBuffer;
    var hp = audioCtx.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 6500;
    var gain = audioCtx.createGain();
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.13, time + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.0001, time + 0.16);
    src.connect(hp).connect(gain).connect(masterGain);
    src.start(time);
    src.stop(time + 0.18);
  }

  function playSnare(time) {
    // layered noise-burst snare/clap, wide modern trap snare tone
    var offsets = [0, 0.01];
    for (var i = 0; i < offsets.length; i++) {
      var t = time + offsets[i];
      var src = audioCtx.createBufferSource();
      src.buffer = noiseBuffer;
      var bp = audioCtx.createBiquadFilter();
      bp.type = "bandpass";
      bp.frequency.value = 1900;
      bp.Q.value = 0.9;
      var gain = audioCtx.createGain();
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.32, t + 0.004);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.15);
      src.connect(bp).connect(gain).connect(masterGain);
      src.start(t);
      src.stop(t + 0.17);
    }
  }

  function playGhost(time) {
    var src = audioCtx.createBufferSource();
    src.buffer = noiseBuffer;
    var bp = audioCtx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.value = 2200;
    bp.Q.value = 1.2;
    var gain = audioCtx.createGain();
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.08, time + 0.003);
    gain.gain.exponentialRampToValueAtTime(0.0001, time + 0.06);
    src.connect(bp).connect(gain).connect(masterGain);
    src.start(time);
    src.stop(time + 0.07);
  }

  function playSub808(time, freq, glide, holdSteps) {
    // sliding 808 sub — the low end that carries a modern rap beat
    var dur = holdSteps * SIXTEENTH;
    var osc = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    var shaper = audioCtx.createWaveShaper();
    var curve = new Float32Array(256);
    for (var i = 0; i < 256; i++) {
      var x = (i / 255) * 2 - 1;
      curve[i] = Math.tanh(x * 1.6);
    }
    shaper.curve = curve;
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, time);
    if (glide) osc.frequency.exponentialRampToValueAtTime(glide, time + dur * 0.6);
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.5, time + 0.02);
    gain.gain.setValueAtTime(0.5, time + Math.max(dur - 0.12, 0.03));
    gain.gain.exponentialRampToValueAtTime(0.0001, time + dur);
    osc.connect(shaper).connect(gain).connect(masterGain);
    osc.start(time);
    osc.stop(time + dur + 0.02);
  }

  function playBell(time, freq) {
    // sparse dark bell/pluck melodic top-line
    var osc = audioCtx.createOscillator();
    var osc2 = audioCtx.createOscillator();
    var filter = audioCtx.createBiquadFilter();
    var gain = audioCtx.createGain();
    osc.type = "sine";
    osc2.type = "triangle";
    osc.frequency.setValueAtTime(freq, time);
    osc2.frequency.setValueAtTime(freq * 2, time);
    filter.type = "lowpass";
    filter.frequency.setValueAtTime(3200, time);
    filter.frequency.exponentialRampToValueAtTime(700, time + 0.6);
    var g2 = audioCtx.createGain();
    g2.gain.value = 0.18;
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.14, time + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, time + 0.7);
    osc.connect(filter);
    osc2.connect(g2).connect(filter);
    filter.connect(gain).connect(masterGain);
    osc.start(time);
    osc2.start(time);
    osc.stop(time + 0.72);
    osc2.stop(time + 0.72);
  }

  function scheduleStep(step, time) {
    if (KICK_STEPS.indexOf(step) !== -1) playKick(time);
    if (SNARE_STEPS.indexOf(step) !== -1) playSnare(time);
    if (GHOST_STEPS.indexOf(step) !== -1) playGhost(time);
    if (ROLL_STEPS.indexOf(step) !== -1) {
      playHatRoll(time, SIXTEENTH);
    } else if (HAT_STEPS.indexOf(step) !== -1) {
      playHat(time, HAT_ACCENT.indexOf(step) !== -1);
    }
    if (OPEN_HAT_STEPS.indexOf(step) !== -1) playOpenHat(time);
    if (BASS_BY_STEP.hasOwnProperty(step)) {
      var ev = BASS_BY_STEP[step];
      playSub808(time, ev.freq, ev.glide, ev.steps);
    }
    if (MELODY_STEPS.hasOwnProperty(step)) playBell(time, MELODY_STEPS[step]);
  }

  function scheduler() {
    while (nextStepTime < audioCtx.currentTime + SCHEDULE_AHEAD) {
      scheduleStep(currentStep, nextStepTime);
      nextStepTime += SIXTEENTH;
      currentStep = (currentStep + 1) % STEPS_PER_PHRASE;
    }
    schedulerTimer = window.setTimeout(scheduler, LOOKAHEAD_MS);
  }

  function startLoop() {
    var ctx = ensureAudioCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();
    if (schedulerTimer) window.clearTimeout(schedulerTimer);
    masterGain.gain.cancelScheduledValues(ctx.currentTime);
    masterGain.gain.setValueAtTime(0, ctx.currentTime);
    masterGain.gain.linearRampToValueAtTime(0.55, ctx.currentTime + 0.4);
    currentStep = 0;
    nextStepTime = ctx.currentTime + 0.05;
    scheduler();
  }

  function stopLoop() {
    if (schedulerTimer) {
      window.clearTimeout(schedulerTimer);
      schedulerTimer = null;
    }
    if (audioCtx && masterGain) {
      masterGain.gain.cancelScheduledValues(audioCtx.currentTime);
      masterGain.gain.setValueAtTime(masterGain.gain.value, audioCtx.currentTime);
      masterGain.gain.linearRampToValueAtTime(0, audioCtx.currentTime + 0.25);
    }
  }

  var soundToggle = document.getElementById("soundToggle");
  var soundIcon = document.getElementById("soundIcon");
  var soundLabel = document.getElementById("soundLabel");

  if (soundToggle) {
    soundToggle.addEventListener("click", function () {
      soundOn = !soundOn;
      soundToggle.setAttribute("aria-pressed", String(soundOn));
      soundIcon.textContent = soundOn ? "🔊" : "🔈";
      soundLabel.textContent = soundOn ? "SOUND ON" : "SOUND OFF";

      if (soundOn) {
        startLoop();
      } else {
        stopLoop();
      }
    });
  }

  /* ---------- confetti burst ---------- */
  var scene = document.getElementById("scene");
  var confettiColors = ["#ff2e93", "#3ee7f0", "#d7ff3e", "#9b5cff", "#ff6fb0"];

  function burstConfetti(count) {
    if (!scene) return;
    for (var i = 0; i < count; i++) {
      var piece = document.createElement("span");
      piece.className = "confetti";
      piece.style.left = 54 + Math.random() * 22 + "%";
      piece.style.background = confettiColors[Math.floor(Math.random() * confettiColors.length)];
      piece.style.animationDuration = (1.4 + Math.random() * 1.2).toFixed(2) + "s";
      piece.style.animationDelay = (Math.random() * 0.4).toFixed(2) + "s";
      scene.appendChild(piece);
      (function (el) {
        window.setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 3000);
      })(piece);
    }
  }

  /* ---------- door open -> transition to collection ---------- */
  var door = document.getElementById("door");
  var doorFrame = document.getElementById("doorFrame");
  var flashVeil = document.getElementById("flashVeil");
  var entering = false;

  function enterHouse() {
    if (entering) return;
    entering = true;

    if (doorFrame) doorFrame.classList.add("opening");
    burstConfetti(26);
    if (soundOn && audioCtx) {
      playKick(audioCtx.currentTime);
      // stop the beat right as the customer steps through — don't carry it into the collection
      stopLoop();
      soundOn = false;
      if (soundToggle) soundToggle.setAttribute("aria-pressed", "false");
      if (soundIcon) soundIcon.textContent = "🔈";
      if (soundLabel) soundLabel.textContent = "SOUND OFF";
    }

    window.setTimeout(function () {
      if (flashVeil) flashVeil.classList.add("show");
    }, 550);

    window.setTimeout(function () {
      window.location.href = door && door.dataset.href ? door.dataset.href : "/collections/all";
    }, 1150);
  }

  if (door) {
    door.addEventListener("click", enterHouse);
    door.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        enterHouse();
      }
    });
  }

  /* Whole first page is now a click target, not just the door itself.
     Attached to #scene (not document/body) so the sound-toggle button in
     the header, which sits outside #scene, keeps working normally without
     also triggering entry. */
  if (scene) {
    scene.addEventListener("click", enterHouse);
  }
})();
